import axios from "axios";

export const baseRequest = axios.create({
  //baseURL: "http://localhost:8000",
  baseURL: "https://fuk-app.pixels2pixels.ch/",
  // baseURL: "https://king-prawn-app-k4oq8.ondigitalocean.app/",

  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

//export const deleteUrl = "http://localhost:8000/";
export const deleteUrl = "https://fuk-app.pixels2pixels.ch/";

//export const csrfUrl = "http://localhost:8000/";

export const csrfUrl = "https://fuk-app.pixels2pixels.ch/";
